import { NotFound, ServerError, UnAuthorized } from '.';
import {
  ColorProps,
  Flex,
  FlexProps,
  Icon,
  IconProps,
  Text,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import {
  AiFillCheckCircle,
  AiFillCloseCircle,
  AiFillInfoCircle,
  AiFillWarning,
} from 'react-icons/ai/index.js';

export type ExceptionStatusType = '403' | '404' | '500';
export type ResultStatus = 'success' | 'error' | 'info' | 'warning';
export type ResultProps = {
  icon?: ReactNode;
  iconProps?: IconProps;
  status?: ExceptionStatusType | ResultStatus;
  title?: ReactNode;
  subTitle?: ReactNode;
  extra?: ReactNode;
  containerProps?: FlexProps;
  children?: ReactNode;
};

export const Result = (props: ResultProps) => {
  const {
    icon,
    iconProps,
    status = 'info',
    title,
    subTitle,
    extra,
    children,
    containerProps,
  } = props;
  const styles = useMultiStyleConfig('Result', {});
  const config: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string | number]: { icon: any; color: ColorProps['color'] };
  } = {
    '403': { icon: UnAuthorized, color: 'red' },
    '404': { icon: NotFound, color: 'red' },
    '500': { icon: ServerError, color: 'red' },
    success: { icon: AiFillCheckCircle, color: 'green.500' },
    error: { icon: AiFillCloseCircle, color: 'red.500' },
    info: { icon: AiFillInfoCircle, color: 'raspberry.500' },
    warning: { icon: AiFillWarning, color: 'orange.500' },
  };
  return (
    <Flex sx={{ ...styles.Container }} {...containerProps}>
      <Flex sx={{ ...styles.StatusIcon }}>
        {icon ? (
          icon
        ) : (
          <Icon
            as={config[status.toString()].icon}
            color={config[status.toString()].color}
            {...iconProps}
          />
        )}
      </Flex>
      <Text sx={{ ...styles.Title }}>{title}</Text>
      {subTitle && <Text sx={{ ...styles.SubTitle }}>{subTitle}</Text>}
      {extra && <Flex sx={{ ...styles.Extra }}>{extra}</Flex>}
      {children && <Text sx={{ ...styles.Children }}>{children}</Text>}
    </Flex>
  );
};
